import * as React from 'react';
/**
 *
 * Original name: camera
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3704%3A536
 *
 */
export const CameraSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "M60 45c-12.393 0-19.5 7.107-19.5 19.5S47.607 84 60 84s19.5-7.107 19.5-19.5S72.393 45 60 45Zm0 33c-9.21 0-13.5-4.29-13.5-13.5S50.79 51 60 51s13.5 4.29 13.5 13.5S69.21 78 60 78Z", fill: "currentColor" }),
    React.createElement("path", { d: "m83.576 34-8.864-15H45.288l-8.864 15H13v54a13.015 13.015 0 0 0 13 13h68a13.015 13.015 0 0 0 13-13V34H83.576ZM101 88a7.006 7.006 0 0 1-7 7H26a7.008 7.008 0 0 1-7-7V40h20.848l8.864-15h22.576l8.864 15H101v48Z", fill: "currentColor" }),
    React.createElement("path", { d: "M29.5 46a4.18 4.18 0 0 0-4.5 4.5 4.18 4.18 0 0 0 4.5 4.5 4.18 4.18 0 0 0 4.5-4.5 4.18 4.18 0 0 0-4.5-4.5ZM95 46H84v6h11v-6Z", fill: "currentColor" })));
